import Component from '../abstracts/Component';
import {Matchmq} from "../utils/ResolutionHandler";

export default class ArticleHeroComponent extends Component {
  get SELECTORS() {
    return {
      heroMedia: '[data-ah-media]',
      heroText: '[data-hero-text]',
      heroTitle: '[data-hero-title]',
    };
  }

  get CLASSNAMES() {
    return {
      titleWhite: 'title-white',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.media = this.$component.querySelector(this.SELECTORS.heroMedia);
    this.text = this.$component.querySelector(this.SELECTORS.heroText);
    this.title = this.$component.querySelector(this.SELECTORS.heroTitle);
    if (Matchmq('9999','1280')===true) {
      this.titleHeight = this.title.offsetHeight+(this.media.offsetHeight / 3);
    } else {
      this.titleHeight = this.title.offsetHeight;
    }
    this.title.style.transform = `translateY(-${this.titleHeight}px)`;
  }

  setHeight() {
    let vh = window.innerHeight * 0.01;
    let header = document.querySelector('header');
    let headerHeight = header ? header.offsetHeight : 0;
    let benefitBar = document.querySelector('[data-benefit-bar]');
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    let height = 100 * vh - headerHeight - barHeight;
    document.documentElement.style.setProperty(
      '--article-hero-height',
      `${height}px`
    );
  }

  listenScroll() {
    this.title.classList.add('transition');
    let isWhite = this.title.classList.contains(this.CLASSNAMES.titleWhite);
    window.addEventListener('scroll', () => {
      let scroll = window.scrollY;
      let offset = scroll - this.titleHeight;
      if (offset >= 0) {
        offset = 0;
      }
      this.title.style.transform = `translateY(${offset}px)`;
      if (-offset < this.titleHeight * 0.75) {
        this.title.classList.remove(this.CLASSNAMES.titleWhite);
      } else if (isWhite) {
        this.title.classList.add(this.CLASSNAMES.titleWhite);
      }
    });
  }

  setCenterView() {
    let viewHeight = window.innerHeight;
    let textHeight = this.text.offsetHeight;
    let headerHeight = document.querySelector('header').offsetHeight;
    let halfViewHeight = (viewHeight - headerHeight) / 2 + headerHeight;
    let position = halfViewHeight - textHeight / 2;
    let root = document.documentElement;
    root.style.setProperty('--article-hero-center', `${position}px`);
  }

  render() {
    this.log('Rendering..');
    this.setHeight();
    this.setCenterView();
    this.listenScroll();
  }
}
